module.exports = __webpack_public_path__ + "static/img/one.8357da38.png";